import React from 'react';
import FacultyAvailabilityComponent from '../../modules/exam/FacultyAvailability';

const ExamSchedulerPage = () => {
  return (
    <div className="container-fluid">
          <FacultyAvailabilityComponent />
    </div>
  );
};

export default ExamSchedulerPage;